import { render, staticRenderFns } from "./SingleImageUploader.vue?vue&type=template&id=513eac32"
import script from "./SingleImageUploader.vue?vue&type=script&lang=js"
export * from "./SingleImageUploader.vue?vue&type=script&lang=js"
import style0 from "./SingleImageUploader.vue?vue&type=style&index=0&id=513eac32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports